import React, { useEffect, useState } from 'react'

import { AudioLevelIndicator } from '../../../../RoomUI/components/AudioLevelIndicator/AudioLevelIndicator'
import { logMessage } from '../../../../Logging/log'

interface VideoPreviewProps {
  deviceId: string
}

const AudioPreview = ({ deviceId }: VideoPreviewProps) => {
  const [audioTrack, setAudioTrack] = useState<MediaStreamTrack | undefined>(
    undefined
  )

  useEffect(() => {
    if (!deviceId) {
      setAudioTrack(undefined)
      return
    }

    navigator.mediaDevices
      .getUserMedia({
        audio: { deviceId: { exact: deviceId } },
      })
      .then((mediaStream) => {
        setAudioTrack(mediaStream.getAudioTracks()[0])
      })
      .catch((error) => {
        logMessage(
          'Issue occurred while previewing audio in device selector.',
          {
            level: 'warning',
            extra: { deviceId, cause: error },
          }
        )
      })
  }, [deviceId])

  return <AudioLevelIndicator audioTrack={audioTrack} enabled />
}

export { AudioPreview }
